export default __webpack_public_path__ + "static/media/apple.c53e0bd0.png";